// extracted by mini-css-extract-plugin
export default {"ConsentModal":"ConsentModal_JXeby","ConsentModal__toggle":"ConsentModal__toggle_G4_5s","ConsentModal__toggle__label":"ConsentModal__toggle__label_n0ZYg"};